export default {
  'costCenters.domain.code': 'Code',
  'costCenters.domain.description': 'Description',
  'costCenters.domain.updatedAt': 'Updated At',
  'costCenters.generateReport': 'Generate Report',
  'costCenters.create': 'Create new cost center',
  'costCenters.modal.report.title': 'Generate Report',
  'costCenters.modal.report.buttons.pdf': 'Generate PDF',
  'costCenters.modal.report.buttons.viewReport': 'View Report',
  'costCenters.modal.report.buttons.rtf': 'Generate RTF',
  'costCenters.modal.report.form.description': 'Description',
  'costCenters.modal.general.new.title': 'New Cost Center',
  'costCenters.modal.general.edit.title': 'Edit Cost Center',
  'costCenters.modal.general.form.description': 'Description',

  'costCenters.create.notification.success': 'Success!',
  'costCenters.create.notification.successDescription':
    'Successfully created cost center!',
  'costCenters.update.notification.success': 'Success!',
  'costCenters.update.notification.successDescription':
    'Successfully updated cost center!',
  'costCenters.contacts.remove.modal.title': 'Remove cost center',
  'costCenters.contacts.remove.modal.content':
    'Do you really want to remove the cost center?',
  'costCenters.contacts.remove.notification.success': 'Success!',
  'costCenters.contacts.remove.notification.successDescription':
    'The cost center has been successfully removed!',
  'costCenters.contacts.remove.modal.okText': 'Remove',
  'costCenters.update.status.message.success':
    'Status of Cost Center successfully changed!',
};
